import { useTheme } from '../../ThemeContext';
import Icon from './Icon';

/**
 * Light/dark switch. Labelled ("Dark mode" / "Light mode") unless compact; the choice is remembered.
 * Not in the EGDL design — added because the portal supports both themes.
 */
export default function ThemeToggle({ compact = false, className }) {
    const { theme, toggleTheme } = useTheme();
    const next = theme === 'dark' ? 'Light mode' : 'Dark mode';
    return (
        <button
            type="button"
            className={'eg-logout' + (className ? ' ' + className : '')}
            onClick={toggleTheme}
            aria-label={`Switch to ${next.toLowerCase()}`}
            title={`Switch to ${next.toLowerCase()}`}
        >
            <Icon name={theme === 'dark' ? 'sun' : 'moon'} />
            {compact ? null : <span>{next}</span>}
        </button>
    );
}
